import React from "react";
import {
  Row,
  Col,
  Card,
  Select,
  Checkbox,
  DatePicker,
  Space,
  Flex,
  Spin,
  Skeleton,
  Typography,
  Button,
  Popover,
  TreeSelect,
  Tag,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import { debounce } from "lodash";
import { useMediaQuery } from "react-responsive";
import dayjs from "dayjs";
import CountryWiseTaskAndSalesMap from "../../page-components/Bdm Analytics/CountryWiseTaskAndSalesMap";
import OrderBudgetAndAmountDetails from "../../page-components/Bdm Analytics/OrderBudgetAndAmountDetails";
import ComparisonAnalytics from "../../page-components/Bdm Analytics/ComparisonAnalytics";
import RefundAnalytics from "../../page-components/Bdm Analytics/RefundAnalytics";
import hierarchyService from "../../services/hierarchyService";
import bdmAnalyticsService from "../../services/bdmAnalyticsService";

import "./bdm.css";
import { CircleX } from "lucide-react";

import { SearchOutlined } from "@ant-design/icons";
const { Title } = Typography;
const { RangePicker } = DatePicker;
function AnalyticsParent() {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [hierarchyData, setHierarchyData] = useState([]);
  const [selectedHierarchy, setSelectedHierarchy] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [parentMap, setParentMap] = useState({});
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedMonth, setSelectedMonth] = useState(dayjs().month() + 1); // Numeric month (1-12)
  const [selectedYear, setSelectedYear] = useState(dayjs().year()); // Change to single month selection
  const [analyticsData, setAnalyticsData] = useState(null); // State for fetched analytics data
  const [isInitialLoad, setIsInitialLoad] = useState(true); // New flag for initial load
  const [loading, setLoading] = useState(false); // Loading state for analytics data
  const [parentUid, setParentUid] = useState(null);
  const [parentDetail, setParentDetail] = useState({ user: null, uid: null });
  const [myTeamloading, setMyTeamLoading] = useState(false);
  // Function to fetch analytics data
  // Function to fetch analytics data

  const fetchAnalyticsData = async (startDate, endDate, month, year, uids) => {
    setLoading(true); // Start loading
    try {
      const result = await bdmAnalyticsService.fetchBdmAnalyticsData(
        startDate,
        endDate,
        month,
        year,
        uids
      );
      if (result.success) {
        console.log(result, "res");
        setAnalyticsData(result.data.data);
      }
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const debouncedFetchAnalyticsData = debounce(fetchAnalyticsData, 300);
  const orderAnalytics = analyticsData?.order_analytics || {};
  console.log(analyticsData, "orderAnalytics");
  const {
    order_budget = [],
    amount_paid = [],
    task_count = 0,
    word_count = 0,
    sales_data = [],
  } = orderAnalytics;
  const { new_customers_count = 0, new_customer_sales = {} } =
    analyticsData?.new_customers_data || {};
  const { total_inr_amount = 0, sales_by_currency = {
  } } =
    new_customer_sales || {};
  console.log(analyticsData?.new_customers_data, "sales_by_currency");
  // Convert API hierarchy to treeData for TreeSelect
  function convertHierarchyToTreeData(hierarchy) {
    return hierarchy.map((item) => ({
      title:
        item.is_active === false ? (
          <span>
            {item.user}{" "}
            <span style={{ fontStyle: "italic", color: "#888" }}>
              {" "}
              (inactive)
            </span>
          </span>
        ) : (
          item.user
        ),
      value: item.uid,
      key: item.uid,
      children:
        item.hierarchy && item.hierarchy.length > 0
          ? convertHierarchyToTreeData(item.hierarchy)
          : undefined,
    }));
  }

  // Build a map from child UID to parent UID
  function buildParentMap(tree, parent = null, map = {}) {
    tree.forEach((node) => {
      map[node.value] = parent;
      if (node.children && node.children.length > 0) {
        buildParentMap(node.children, node.value, map);
      }
    });
    return map;
  }

  // Helper to get all ancestor UIDs for a node
  function getAllAncestors(uid, map) {
    const ancestors = [];
    let current = map[uid];
    while (current) {
      ancestors.push(current);
      current = map[current];
    }
    return ancestors;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setMyTeamLoading(true);
        const result = await hierarchyService.fetchBdmAnalyticsHierarchy();

        if (result.success) {
          const data = result.data.data;
          // Filter out parent UID from hierarchyData if present
          const filteredHierarchy = data.hierarchy.filter((item) => {
            // Allow self-reference ONLY if it has children
            if (item.uid === data.uid) {
              return item.hierarchy && item.hierarchy.length > 0;
            }
            return true;
          });
          setHierarchyData(filteredHierarchy);
          setParentDetail({ uid: data.uid, user: data.user }); // Save UID and user
          setSelectedHierarchy([data.uid]);
          // Build treeData for TreeSelect (add parent as selectable node at top)
          // Helper: Recursively check if a uid exists in hierarchy
          function uidInHierarchy(hierarchy, uid) {
            for (const item of hierarchy) {
              if (item.uid === uid) return true;
              if (item.hierarchy && uidInHierarchy(item.hierarchy, uid))
                return true;
            }
            return false;
          }

          // Helper: Recursively add (You) to the node if uid matches data.uid
          function markYouInHierarchy(hierarchy, uid) {
            return hierarchy.map((item) => {
              let nodeTitle = item.user;
              if (item.uid === uid) {
                nodeTitle = `${item.user} (You)`;
              }
              return {
                title: nodeTitle,
                value: item.uid,
                key: item.uid,
                children:
                  item.hierarchy && item.hierarchy.length > 0
                    ? markYouInHierarchy(item.hierarchy, uid)
                    : undefined,
              };
            });
          }

          function convertHierarchyToTreeData(hierarchy) {
            return hierarchy.map((item) => ({
              title:
                item.is_active === false ? (
                  <span>
                    {item.user}{" "}
                    <span style={{ fontStyle: "italic", color: "#888" }}>
                      {" "}
                      (inactive)
                    </span>
                  </span>
                ) : (
                  item.user
                ),
              value: item.uid,
              key: item.uid,
              children:
                item.hierarchy && item.hierarchy.length > 0
                  ? convertHierarchyToTreeData(item.hierarchy)
                  : undefined,
            }));
          }

          // Helper: Remove and return node with uid from hierarchy
          function extractUserNode(hierarchy, uid) {
            let foundNode = null;
            function recurse(nodes) {
              return nodes.filter((item) => {
                if (item.uid === uid) {
                  foundNode = { ...item };
                  return false;
                }
                if (item.hierarchy && item.hierarchy.length > 0) {
                  item.hierarchy = recurse(item.hierarchy);
                }
                return true;
              });
            }
            const newHierarchy = recurse([...hierarchy]);
            return { foundNode, newHierarchy };
          }

          let tree = [];
          tree.push({ title: "Total", value: "Total", key: "Total" });
          if (!uidInHierarchy(filteredHierarchy, data.uid)) {
            tree.push({
              title: `${data.user} (You)`,
              value: data.uid,
              key: data.uid,
              children: [],
            });
            tree = tree.concat(convertHierarchyToTreeData(filteredHierarchy));
          } else {
            // Extract user node, move to top, append (You)
            const { foundNode, newHierarchy } = extractUserNode(
              filteredHierarchy,
              data.uid
            );
            if (foundNode) {
              tree.push({
                title: `${foundNode.user} (You)`,
                value: foundNode.uid,
                key: foundNode.uid,
                children:
                  foundNode.hierarchy && foundNode.hierarchy.length > 0
                    ? convertHierarchyToTreeData(foundNode.hierarchy)
                    : undefined,
              });
              tree = tree.concat(convertHierarchyToTreeData(newHierarchy));
            } else {
              tree = tree.concat(convertHierarchyToTreeData(filteredHierarchy));
            }
          }
          setTreeData(tree);
          setParentMap(buildParentMap(tree));
          // Automatically fetch analytics data for the default user
          fetchAnalyticsData(
            null, // No date range
            null, // No date range
            dayjs().month() + 1, // Current month
            dayjs().year(), // Current year
            [data.uid] // Default user UID
          );
          setMyTeamLoading(false);
        }
      } catch (error) {
        setMyTeamLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  // TreeSelect change handler
  // Only store the checked values as selectedHierarchy. Don't add ancestors.
  // With treeCheckStrictly, checkedNodes is an array of checked nodes: [{label, value, halfChecked}]
  const handleTreeSelectChange = (checkedNodes) => {
    function getAllDescendantUids(node) {
      let uids = [];
      if (node.value !== "Total") uids.push(node.value);
      if (node.children) {
        node.children.forEach((child) => {
          uids = uids.concat(getAllDescendantUids(child));
        });
      }
      return uids;
    }

    function getAllUidsFromTree(tree) {
      let uids = [];
      for (const node of tree) {
        if (node.value !== "Total") {
          uids.push(node.value);
        }
        if (node.children && node.children.length > 0) {
          uids = uids.concat(getAllUidsFromTree(node.children));
        }
      }
      return uids;
    }

    let values = checkedNodes.map((node) => node.value);

    // Handle 'Total' select/deselect logic
    if (values.includes("Total")) {
      const allUids = getAllUidsFromTree(treeData);
      // If all are already selected, deselect all
      const allSelected =
        allUids.length > 0 && allUids.every((uid) => values.includes(uid));
      if (allSelected) {
        setSelectedHierarchy([]);
      } else {
        setSelectedHierarchy(allUids);
      }
      return;
    }

    setSelectedHierarchy(values);
  };

  // const handleSelectChange = (value) => {
  //   console.log("Selected value:", value); // Debug log

  //   if (value.includes("Total")) {
  //     // When "Select All" is selected, set selectedHierarchy to all user uids
  //     setSelectedHierarchy(hierarchyData.map((item) => item.uid));
  //   } else {
  //     // For single or multiple selections, update selectedHierarchy
  //     setSelectedHierarchy(value);
  //   }
  // };

  // const handleSelectChange = (value) => {
  //   console.log("Selected value:", value); // Debug log

  //   if (value === "Total") {
  //     // For "Total" selection, get all UIDs
  //     setSelectedHierarchy(hierarchyData.map((item) => item.uid));
  //     // setSelectedHierarchy(hierarchyData.map((item) => item.uid));
  //   } else if (value) {
  //     // For single selection, wrap in array to maintain consistent format
  //     setSelectedHierarchy(value);
  //   }
  // };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    setDateRange([null, null]);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
    setDateRange([null, null]);
    setSelectedMonth(null);
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates || [null, null]);
    setSelectedMonth(null);
    setSelectedYear(null);
  };
  // const hierarchyOptions = [
  //   { value: "Total", label: "Total" }, // "Total" remains the first option
  //   ...hierarchyData.map((item) => ({
  //     value: item.uid,  // UID should be the value
  //     label: item.user, // Name should be the label
  //   })),
  // ];
  // hierarchyOptions are no longer needed, replaced by treeData

  const monthOptions = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];
  const yearOptions = Array.from({ length: 10 }, (_, i) => {
    const year = dayjs().year() - i;
    return { label: year, value: year };
  });
  const handleSearch = () => {
    // Trigger fetch immediately for manual submissions
    // Remove 'Total' from selectedHierarchy for API payload
    const payloadUids = selectedHierarchy.filter((uid) => uid !== "Total");
    fetchAnalyticsData(
      dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : null,
      dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : null,
      selectedMonth,
      selectedYear,
      payloadUids
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleCancel = () => {
    setSelectedMonth(dayjs().month() + 1); // Set to current month (1-12)
    setSelectedYear(dayjs().year()); // Set to current year
    setDateRange([null, null]); // Clear date range

    // Fetch data with default values
    fetchAnalyticsData(
      null, // No date range filter
      null, // No date range filter
      dayjs().month() + 1, // Current month
      dayjs().year(), // Current year
      [] // No specific hierarchy filter
    );
  };

  return (
    <Flex style={{ padding: "10px", width: "100%" }} gap={10} vertical>
      <div style={{ width: "100%" }}>
        <div
          style={{
            background: "#eceff1",
            padding: "20px",
            borderRadius: "8px",
          }}>
          <div
            style={{
              marginBottom: 16,
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}>
            <TreeSelect
              className="bdm-user"
              style={{ width: 220, textAlign: "left" }}
              value={selectedHierarchy}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              treeData={treeData}
              placeholder={myTeamloading ? "Fetching Team" : "Select Users"}
              treeCheckable={true}
              treeCheckStrictly={true} // Enable strict check
              showCheckedStrategy={TreeSelect.SHOW_PARENT}
              onChange={handleTreeSelectChange}
              onKeyDown={handleKeyDown}
              allowClear
              multiple
              loading={myTeamloading}
              showSearch
              filterTreeNode={(input, node) => {
                let label = "";
                if (typeof node.title === "string") {
                  label = node.title;
                } else if (React.isValidElement(node.title)) {
                  if (node.title.props && node.title.props.children) {
                    if (Array.isArray(node.title.props.children)) {
                      label = node.title.props.children[0];
                    } else {
                      label = node.title.props.children;
                    }
                  }
                }
                return (
                  label && label.toLowerCase().includes(input.toLowerCase())
                );
              }}
            />

            <Select
              placeholder="Select Year"
              value={selectedYear}
              onChange={handleYearChange}
              onKeyDown={handleKeyDown}
              allowClear
              style={{ width: 220, textAlign: "left" }}>
              {yearOptions.map((year) => (
                <Select.Option key={year.value} value={year.value}>
                  {year.label}
                </Select.Option>
              ))}
            </Select>

            {/* Month-wise Checkbox */}

            <Select
              placeholder="Select Month"
              value={selectedMonth}
              onChange={handleMonthChange}
              onKeyDown={handleKeyDown}
              style={{ width: 220, textAlign: "left" }}
              allowClear>
              {monthOptions.map((month) => (
                <Select.Option key={month.value} value={month.value}>
                  {month.label}
                </Select.Option>
              ))}
            </Select>

            {/* Date Range Picker */}
            <RangePicker
              value={dateRange}
              onChange={handleDateRangeChange}
              onKeyDown={handleKeyDown}
              style={{ width: 220, textAlign: "left" }}
              format="YYYY-MM-DD"
            />
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                type="primary"
                style={{ background: "#040724" }}
                icon={<SearchOutlined />}
                onClick={handleSearch}></Button>
              <Button
                style={{ border: "none" }}
                type="default"
                icon={<CircleX />}
                onClick={handleCancel}></Button>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <Flex
          style={{ width: "100%", height: "80vh" }}
          justify="center"
          align="center">
          <Spin size="large" tip="Loading analytics data..." />
        </Flex>
      ) : (
        <Row
          gutter={[16, 16]}
          style={{
            flexDirection: isMobile ? "column" : "row",
            width: "100%",
          }}>
          <Col order={1} lg={12}>
            <Flex
              style={{
                width: "100%",
                flexDirection: isMobile ? "column" : "row",
              }}
              gap={10}>
              <Flex
                justify={isMobile ? "flex-start" : "center"}
                align="center"
                style={{
                  background: "white",
                  padding: 8,
                  borderRadius: 4,
                }}>
                <Title level={5} style={{ margin: 0, padding: 0 }}>
                  Task Count : {task_count}
                </Title>
              </Flex>
              <Flex
                justify={isMobile ? "flex-start" : "center"}
                align="center"
                style={{
                  background: "white",
                  padding: 8,
                  borderRadius: 4,
                  textAlign: "left",
                }}>
                <Title level={5} style={{ margin: 0, padding: 0 }}>
                  Word Count : {word_count}
                </Title>
              </Flex>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  background: "white",
                  padding: 8,
                  borderRadius: 4,
                }}>
                <Popover
                  trigger="click"
                  content={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        background: "#f3f4f6",
                        minWidth: "210px",
                        backdropFilter: "10px",
                        padding: "10px",
                        borderRadius: "10px",
                        border: " 1px solid #9ca3af",
                        gap: "10px",
                      }}>
                      <strong>Sales Data</strong>
                      <div
                        style={{
                          padding: "8px",
                          backgroundColor: "#f4f6f9",
                        }}>
                        {sales_data.length > 0 ? (
                          sales_data.map((sale, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-between",
                              }}>
                              <div> {sale.currency}</div>
                              <div>{sale.amount}</div>
                            </div>
                          ))
                        ) : (
                          <div>No sales data available</div>
                        )}
                      </div>
                    </div>
                  }>
                  <Flex justify="center" align="center">
                    <Title level={5} style={{ margin: 0, padding: 0 }}>
                      Sales Value:
                    </Title>
                    <Button type="link">Click to View</Button>
                  </Flex>
                </Popover>
              </div>
            </Flex>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                  <span>Order Analytics</span>
                  <Tooltip title="Result excludes cancelled, unassigned, and unpaid tasks (Without Any Solution)">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: 8,
                        fontSize: 16,
                        color: "#1890ff",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </div>
              }
              bordered
              style={{
                textAlign: "left",

                minHeight: isMobile ? "max-content" : 420,
                maxHeight: isMobile ? "max-content" : 420,
                marginTop: "10px",
              }}>
              <OrderBudgetAndAmountDetails data={analyticsData} />
            </Card>
          </Col>

          <Col order={2} sm={24} lg={12}>
            <Flex
              style={{
                width: "100%",
                flexDirection: isMobile ? "column" : "row",
            
              }}
              gap={10}>
              <Flex
                justify={isMobile ? "flex-start" : "center"}
                align="center"
                style={{
                  background: "white",
                  padding: 8,
                  borderRadius: 4,
                }}>
                <Title level={5} style={{ margin: 0, padding: 0 }}>
                  Customer Count : {new_customers_count}
                </Title>
              </Flex>
              <Flex
                justify={isMobile ? "flex-start" : "center"}
                align="center"
                style={{
                  background: "white",
                  padding: 8,
                  borderRadius: 4,
                  textAlign: "left",
                }}>
                <Title level={5} style={{ margin: 0, padding: 0 }}>
                  Total INR Sales : {total_inr_amount}
                </Title>
              </Flex>
              {/* New Customers Section */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  background: "white",
                  padding: 8,
                  borderRadius: 4,
                  minWidth: 220,
                }}>
                <Popover
                  trigger="click"
                  content={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        background: "#f3f4f6",
                        minWidth: "270px",
                        backdropFilter: "10px",
                        padding: "10px",
                        borderRadius: "10px",
                        border: " 1px solid #9ca3af",
                        gap: "10px",
                      }}>
                      <strong>New Customer Sales by Currency</strong>
                      <div
                        style={{
                          padding: "8px",
                          backgroundColor: "#f4f6f9",
                        }}>
                        {sales_by_currency &&
                        Object.keys(sales_by_currency).length > 0 ? (
                          <div>
                            <div
                              style={{
                                display: "flex",
                                fontWeight: "bold",
                                justifyContent: "space-between",
                              }}>
                              <span style={{ width: 60 }}>Currency</span>
                              <span style={{ width: 90, textAlign: "right" }}>
                                Amount
                              </span>
                              <span style={{ width: 90, textAlign: "right" }}>
                                INR Value
                              </span>
                            </div>
                            {Object.entries(sales_by_currency).map(
                              ([currency, value]) => (
                                <div
                                  key={currency}
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "space-between",
                                    marginTop: 4,
                                  }}>
                                  <div style={{ width: 60 }}>{currency}</div>
                                  <div
                                    style={{ width: 90, textAlign: "right" }}>
                                    {value.total_amount?.toLocaleString?.() ??
                                      "-"}
                                  </div>
                                  <div
                                    style={{ width: 90, textAlign: "right" }}>
                                    ₹
                                    {value.total_inr_amount?.toLocaleString?.(
                                      "en-IN"
                                    ) ?? "-"}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        ) : (
                          <div>No new customer sales data available</div>
                        )}
                      </div>
                    </div>
                  }>
                  <Flex
                    justify="center"
                    align="center"
                    style={{ marginTop: 4 }}>
                    <Typography.Text
                      style={{
                        marginRight: 4,
                        fontWeight: "bold",
                        
                      }}>
                      Sales By Currency:
                    </Typography.Text>
                    <Button type="link" style={{ padding: 0, marginLeft: 4 }}>
                      Click To View
                    </Button>
                  </Flex>
                </Popover>
              </div>
            </Flex>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",

                  }}>
                  <span>Comparison Analytics</span>
                  <Tooltip title="Note : Compare with the last year same month if you select 'Month Wise' and with the last 3 previous year if you choose 'Year Wise'.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: 8,
                        fontSize: 16,
                        color: "#1890ff",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </div>
              }
              bordered
              style={{
                textAlign: "left",
                minHeight: isMobile ? "max-content" : 470,
                maxHeight: isMobile ? "max-content" : 470,
                marginTop: "10px",
              }}
           >
              <ComparisonAnalytics
                data={
                  analyticsData || {
                    comparision_analytics: { monthwise: {}, yearwise: {} },
                  }
                }
              />
            </Card>
          </Col>

          <Col order={3} lg={12}>
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                  <span>Country and Sales</span>
                  <Tooltip title="Tasks in the 'Others' category are those for which the client's country or contact number (with country code) has not been updated.">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: 8,
                        fontSize: 16,
                        color: "#1890ff",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </div>
              }
              bordered
              style={{
                textAlign: "left",
                minHeight: isMobile ? "max-content" : "max-content",
                maxHeight: isMobile ? "max-content" : "max-content",
              }}>
              <CountryWiseTaskAndSalesMap data={analyticsData} />
            </Card>
          </Col>
          <Col order={4} lg={12}>
            <Card
              title="Refund Analytics"
              bordered
              style={{
                textAlign: "left",
                minHeight: isMobile ? "max-content" : 470,
                maxHeight: isMobile ? "max-content" : 470,
              }}>
              <RefundAnalytics refundData={analyticsData?.refund_analytics} />
            </Card>
          </Col>
        </Row>
      )}
    </Flex>
  );
}

export default AnalyticsParent;
